import { Injectable } from '@angular/core';
import { DatabaseGwService } from '../database-gw.service';

@Injectable({
  providedIn: 'root'
})
export class CoaTransactionSummaryService extends DatabaseGwService{

  URL_PATH: string="/coa-trans-summary";
}
